import { ReactElement } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import styled from 'styled-components'
import { useFormikContext } from 'formik'

import Avatar from 'components/v2/Avatar'
import FormLayout from 'components/v2/FormLayout'
import { Input } from 'components/Input'
import ItineraryState from 'components/v2/ItineraryState'
import { Label } from 'components/v2/Label'
import { InputDate } from 'components/v2/InputDate'
import { IEditServiceForm } from 'features/Services/components/EditService/types'

const ServiceDetailsFormCard = styled(FormLayout.Card)`
  padding: 14.5px 24px;
`

const ServiceDetailsContainer = styled.div<TSFixMe>`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`

const ServiceDetailContainer = styled.div<{ small?: boolean }>`
  align-items: center;
  display: flex;
  gap: ${({ small }): string => (small ? '8px' : '16px')};
`

const ServiceDetailLabel = styled(Label)<TSFixMe>`
  margin-bottom: 0;
`

const ServiceCodeInput = styled(Input)<TSFixMe>`
  width: 150px;

  & > div {
    background-color: #e0d6ff4d;
  }

  & > div > input:disabled {
    color: #423f9a;
    opacity: 0.7;
    text-align: center;
  }
`

const CreatedDateInput = styled(InputDate)<TSFixMe>`
  width: 150px;

  & > div {
    background-color: #e0d6ff4d;

    input:disabled {
      color: #423f9a;
      opacity: 0.7;
    }

    svg {
      fill: #916ee8;
    }
  }
`

const messages = defineMessages({
  activeStatus: {
    id: 'service.details.status.active',
    defaultMessage: 'Active'
  },
  inactiveStatus: {
    id: 'service.details.status.inactive',
    defaultMessage: 'Inactive'
  }
})

export const ServiceDetailsCard = (): ReactElement => {
  const intl = useIntl()
  const { values } = useFormikContext<IEditServiceForm>()

  return (
    <ServiceDetailsFormCard small>
      <ServiceDetailsContainer>
        <ServiceDetailContainer small>
          <ServiceDetailLabel>
            <FormattedMessage id="service.details.serviceCode.label" defaultMessage="Service" />
          </ServiceDetailLabel>
          <ServiceCodeInput value={values.code} small noBorder disabled />
        </ServiceDetailContainer>
        <ServiceDetailContainer small>
          <ServiceDetailLabel>
            <FormattedMessage id="service.details.createdAt.label" defaultMessage="Created At" />
          </ServiceDetailLabel>
          <CreatedDateInput
            intl={intl}
            value={values.createdAt}
            onChange={(): void => undefined}
            small
            noBorder
            disabled
          />
        </ServiceDetailContainer>
        <ServiceDetailContainer>
          <ServiceDetailLabel>
            <FormattedMessage id="service.details.createdBy.label" defaultMessage="Created By" />
          </ServiceDetailLabel>
          <Avatar name={values.createdBy} size="sm" />
        </ServiceDetailContainer>
        <ServiceDetailContainer>
          <ServiceDetailLabel>
            <FormattedMessage id="service.details.status.label" defaultMessage="Status" />
          </ServiceDetailLabel>
          <ItineraryState
            state={values.isActive ? 'success' : 'error'}
            label={intl.formatMessage(values.isActive ? messages.activeStatus : messages.inactiveStatus)}
          />
        </ServiceDetailContainer>
      </ServiceDetailsContainer>
    </ServiceDetailsFormCard>
  )
}
